var EventEmitter = require('events').EventEmitter;

module.exports = new EventEmitter();


// WEBPACK FOOTER //
// ./js/base/emitter.js